/** Shared SweetAlert2 styling (dark console theme). */
export const swalBase = {
  background: '#151b2e',
  color: 'rgba(255, 255, 255, 0.92)',
  confirmButtonColor: '#7c5cff',
  cancelButtonColor: 'rgba(255, 255, 255, 0.2)',
  /** Sit above portaled UI (e.g. User Management modal at z-index 3000). */
  customClass: {
    container: 'swal-above-app-modal',
  },
};
